import React, { useState, useRef } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import reactT from '../../components/reactT';

function CopyToClipboard() {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  return (
    <>
    <button 
    className="copy-to-clipboard p-0 border-0 d-flex align-items-center bg-white"
    ref={target}
    onClick={(e) => {
      const textToCopy =
      e.target.parentNode.querySelector('.citation-text').innerText;
      
      if (window.isSecureContext) {
        navigator.clipboard.writeText(textToCopy);
      } else {
        const textarea = document.createElement("textarea");
        textarea.textContent = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      setShow(!show)
      setTimeout( () => {setShow(false) }, 1000);
    }
    
    
    }
    >
    {reactT("Copy to Clipboard")}
    </button>
      <Overlay target={target.current} show={show} placement="bottom">
        {(props) => (
          <Tooltip id="copy-to-clipboard" {...props}>
            {reactT("Copied!")}
          </Tooltip>
        )}
      </Overlay>
    </>
  );
}

export default CopyToClipboard;